module.exports = __webpack_public_path__ + "img/LSSYellowBelt.73d1f4f3.jpg";